import { render, staticRenderFns } from "./Packing_slip.vue?vue&type=template&id=268edf81&scoped=true&"
import script from "./Packing_slip.vue?vue&type=script&lang=js&"
export * from "./Packing_slip.vue?vue&type=script&lang=js&"
import style0 from "./Packing_slip.vue?vue&type=style&index=0&id=268edf81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268edf81",
  null
  
)

export default component.exports